// extracted by css-extract-rspack-plugin
export default {"playgroundContainer":"ModelsPlaygroundRoute-module__playgroundContainer__O7apU","playgroundPanel":"ModelsPlaygroundRoute-module__playgroundPanel__Iezm4"};